import { render } from "./BaseButton.vue?vue&type=template&id=bbe10472&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=bbe10472&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bbe10472"

export default script